import Cookies from 'js-cookie';
const expiredAt = new Date('Fri, 31 Dec 9999 23:59:59 GMT');
const rootDomain = process.env.VUE_APP_COOKIE_HOST;

export function setLoginFrom() {
  Cookies.set(
    'login_from', 
    'globallayer',
    {
      expires: expiredAt,
      domain: rootDomain
    }
  );
}